import request from "@/utils/request";

// 查询充电站
export const getSite = params => {
	return request({
		url: "/site",
		method: "GET",
		params,
	});
};

// 保存充电站
export const setSite = data => {
	return request({
		url: "/site",
		method: "POST",
		data,
	});
};

// 删除充电站
export const removeSite = params => {
	return request({
		url: "/site",
		method: "DELETE",
		params,
	});
};

// 保存资费标准
export const setFeePolicy = data => {
	return request({
		url: "/feepolicy",
		method: "POST",
		data,
	});
};
export const setPowerPool = data => {
	return request({
		url: "/powerPool",
		method: "POST",
		data,
	});
};
export const getPowerPool = params => {
	return request({
		url: "/powerPool",
		method: "GET",
		params,
	});
};
export const deletePowerPool = params => {
	return request({
		url: "/powerPool",
		method: "DELETE",
		params,
	});
};
export const getPowerPoolStats = params => {
	return request({
		url: "/powerPool/stats",
		method: "GET",
		params,
	});
};
